/* 🤖 this file was generated by svg-to-ts */
export const iconMenu: {
    name: 'menu';
    data: string;
} = {
    name: 'menu',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12"><path fill="#000" fill-rule="evenodd" d="M16.5 10.418a.65.65 0 0 1 .096 1.293l-.096.007h-15a.65.65 0 0 1-.096-1.293l.096-.007zm0-5.068a.65.65 0 0 1 .096 1.293l-.096.007h-15a.65.65 0 0 1-.096-1.293L1.5 5.35zm0-5.068a.65.65 0 0 1 .096 1.293l-.096.007h-15A.65.65 0 0 1 1.404.29L1.5.282z"/></svg>`
};
